module.exports = React;